import React from 'react';
import { Dialog } from '@mui/material';
import { useTheme, Theme, SxProps, Box} from '@mui/material';

interface ModalProps {
  className?: string;
  open: boolean;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  handleClose?: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ open, width = 'sm', handleClose, children }) => {
  const theme = useTheme();
  const sxStyles = useSxStyles(theme);

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (handleClose) handleClose();
      }}
      maxWidth={width}
      PaperProps={{ sx: { ...sxStyles.root} }}
      disableEscapeKeyDown
      // 'paper', not 'body': body-scroll lets the paper grow to its content, so a tall
      // dialog (the assign modal's driver list auto-expands its unavailable drop-down
      // when nobody is recommendable) pushed the pinned ModalFooter — Reassign/Unassign —
      // a full viewport below the fold, reading as "the buttons are missing". Paper-scroll
      // caps the dialog to the viewport, the content area scrolls internally (its
      // DialogContent already carries overflowY: auto), and the header and footer stay
      // visible whatever the list length.
      scroll='paper'
    >
      <Box sx={sxStyles.main}>{children}</Box>
    </Dialog>
  );
};

export default Modal;

const useSxStyles = (theme: Theme): Record<string, SxProps<Theme> | undefined> => ({
  root: {
    width: '100%',
    margin: theme.spacing(2),
  },
  main: {
    position: 'relative',
    textAlign: 'left',
    // Under scroll='paper' the Paper is a max-height flex column; this Box sits between
    // it and the Dialog sections, so it must pass the constraint through — flex column,
    // shrinkable (minHeight: 0) — or DialogContent never scrolls and the footer clips.
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
});